import styled from 'styled-components';
import { fontSize } from '../mixins';


const Headline = styled.p`
    ${fontSize(16)};
    line-height: 19px;
    letter-spacing: -0.005em;
    color: #323232;
    margin: ${({customMargin}) => customMargin || 0};
    ${({ customStyles }) => customStyles};
`;

const MainDescription = ({children, customMargin, customStyles = ''}) => <Headline customMargin={customMargin} customStyles={customStyles}>{children}</Headline>;

export default MainDescription;